<template>
	<section class="tp-Purchases">
		<DashboardPurchaseTableReact
			:purchases="purchases"
			:loading="loading"
			:onConfirm="handleConfirmation"
			:onCancel="handleCancel"
		/>
	</section>
</template>

<script>
import ReactInVue from "@/components/logic/wrappers/ReactInVue";
import { DashboardPurchaseTable } from "@/modules/dashboard/components/DashboardPurchaseTable";

const DashboardPurchaseTableReact = ReactInVue(DashboardPurchaseTable);

export default {
	components: {
		DashboardPurchaseTableReact,
	},
	data() {
		return {
			purchases: [],
			loading: false,

			item: "",
			material: null,
			storeBoxDialog: false,
			storeBox: "",
		};
	},

	computed: {
		total() {
			return this.purchases ? this.purchases.lenght : 0;
		},
	},

	created() {
		this.fetchData();
	},

	methods: {
		async fetchData() {
			this.loading = true;

			try {
				const { purchases } = await this.$stellar.action(
					"getPurchaseMoreThanXDays",
				);
				this.purchases = purchases;
			} catch (e) {
				// Do nothing!
			} finally {
				this.loading = false;
			}
		},

		/**
		 * Format the estimated delivery date interval.
		 */
		estimateDelivery(purchase) {
			let startDate = null;
			let endDate = null;

			if (purchase.origin === "europe") {
				startDate = new Date(purchase.createdAt);
				endDate = dateMarginForEurope(new Date(purchase.createdAt));
			} else {
				startDate = dateMarginWordStart(new Date(purchase.createdAt));
				endDate = dateMarginWordEnd(new Date(purchase.createdAt));
			}

			// format date
			startDate = format(DATE_DAY_FROM_MONTH, startDate);
			endDate = format(DATE_DAY_FROM_MONTH, endDate);

			return `(${startDate} - ${endDate})`;
		},

		showFixBtn(purchase) {
			return !["normal", "verified"].includes(purchase.state);
		},

		europeanFix(purchase) {
			this.$confirm("Arranja-se material?", "Verificação", {
				confirmButtonText: "Sim",
				cancelButtonText: "Não",
				type: "info",
			})

				.then((_) => {
					this.$confirm("Cliente concorda em esperar?", "Verificação", {
						confirmButtonText: "Sim",
						cancelButtonText: "Não",
						type: "info",
					})

						.then(() => {
							// remove purchase
							this.$stellar.action("deletePurchase", { id: this.purchase.id });

							// set the material
							this.$refs.purchases.setMaterial(
								purchase.material,
								purchase.quantity,
							);

							// show the purchase form
							this.$refs.purchases.show();
						})
						.catch(() => {});
				})

				// There is no material for this purchase
				.catch(() => {});
		},

		handleProblemResolution(purchase) {
			if (purchase.origin === "europe") {
				this.europeanFix(purchase);
			}
		},

		/**
		 * Confirm the purchase
		 */
		handleConfirmation(purchase) {
			// save the storebox to use it later
			let _storeBox = purchase.material.storeBox;

			this.$confirm(
				"Tem a certeza que pretende efetivar a compra?",
				"Efetivar compra",
				{
					type: "warning",
					cancelButtonText: "Cancelar",
					confirmButtonText: "Continuar",
				},
			)
				.then((_) => {
					if (!_storeBox) {
						return this.$prompt(
							"Por favor, indique a caixa do material.",
							"Caixa do Material",
						).then(({ value }) => {
							// save the storebox to use it later
							_storeBox = value;
							return value;
						});
					}

					return null;
				})
				.then((storeBox) => {
					// start loading
					this.loading = true;

					// make the API call
					return this.$stellar.action("confirmPurchase", {
						id: purchase.id,
						storeBox,
					});
				})
				.then((_) => {
					// remove the item from the purchase list
					const index = this.purchases.findIndex(
						(item) => item.id === purchase.id,
					);
					this.purchases.splice(index, 1);
					// show a success message
					this.$message.success("Compra efetivada");

					// show where the material must be placed
					this.$alert(`A peça deve ser colocada na caixa ${_storeBox}.`);

					// disable loading
					this.loading = false;
				})
				.catch((e) => {
					this.loading = false;
				});
		},

		/**
		 * Cancel purchase
		 */
		handleCancel(purchase) {
			this.$confirm(
				"Tem a certeza que pretende cancelar a compra?",
				"Cancelar compra",
				{
					type: "warning",
					cancelButtonText: "Cancelar",
					confirmButtonText: "Continuar",
				},
			)
				.then((_) => {
					return this.$stellar.action("removePurchase", {
						id: purchase.id,
					});
				})
				.then((response) => {
					// remove the item from the purchase list
					const index = this.purchases.findIndex(
						(item) => item.id === purchase.id,
					);
					this.purchases.splice(index, 1);

					// if the containsRequests is set we must show a message informing that
					// the material requests was canceled
					if (response.containsRequests) {
						this.$alert(
							"Material voltou para os pedidos.",
							"Pedidos de Materiais",
						);
					}

					// show a success message
					this.$message.success("Compra cancelada.");
				})
				.catch((_) => {});
		},
	},
};
</script>

<style lang="scss">
.tp {
	&-Purchases {
		max-width: 98%;
		margin: 10px auto;

		&__item {
			transition: 0.3s all ease;

			&.is-overtime:not(:hover) {
				color: white;
				background-color: #ffa99b;

				.ui-List__item__title {
					color: white;
				}
			}

			&.is-first_verification:not(:hover) {
				color: white;
				background-color: #ffcd5c;

				.ui-List__item__title {
					color: white;
				}
			}
		}

		&__addBtn {
			margin-bottom: 10px !important;
		}

		&__pagination {
			padding-left: 0 !important;
			margin: 8px 0;
		}
	}
}
</style>
